import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, CheckCircle2 } from 'lucide-react';
const notifications = [{
  name: 'Valentina M.',
  location: 'Córdoba',
  pack: 'MegaPack Familiar 🏆'
}, {
  name: 'Luciana P.',
  location: 'Rosario',
  pack: 'MegaPack Descanso Profundo 📘'
}, {
  name: 'Rodrigo A.',
  location: 'Buenos Aires',
  pack: 'MegaPack Familiar 🏆'
}];
export function PurchaseNotification() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Initial delay before showing first notification
    const initialDelay = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    return () => clearTimeout(initialDelay);
  }, []);
  useEffect(() => {
    if (!isVisible) {
      // When hidden, wait 15 seconds then show next
      const timer = setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % notifications.length);
        setIsVisible(true);
      }, 15000);
      return () => clearTimeout(timer);
    } else {
      // When visible, hide after 5 seconds
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [isVisible]);
  const current = notifications[currentIndex];
  return <div className="fixed bottom-4 left-4 z-50 pointer-events-none" data-id="element-333">
      <AnimatePresence data-id="element-334">
        {isVisible && <motion.div initial={{
        opacity: 0,
        y: 50,
        x: -20
      }} animate={{
        opacity: 1,
        y: 0,
        x: 0
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.9
      }} transition={{
        type: 'spring',
        stiffness: 400,
        damping: 25
      }} className="bg-night-light rounded-lg shadow-2xl border border-white/10 p-4 max-w-sm pointer-events-auto flex gap-3" data-id="element-335">
            <div className="shrink-0 pt-1" data-id="element-336">
              <CheckCircle2 className="w-5 h-5 text-green-500" data-id="element-337" />
            </div>
            <div className="flex-grow pr-4" data-id="element-338">
              <p className="text-sm font-bold text-gray-400 uppercase tracking-wider mb-1" data-id="element-339">
                Compra verificada
              </p>
              <p className="text-sm text-white" data-id="element-340">
                <span className="font-bold" data-id="element-341">{current.name}</span> de{' '}
                {current.location} compró
              </p>
              <p className="text-sm font-semibold text-gold mt-0.5" data-id="element-342">
                {current.pack}
              </p>
            </div>
            <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-200 transition-colors" data-id="element-343">
              <X className="w-4 h-4" data-id="element-344" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}